import { Presentation, Theme } from "../lib/types";

const blueWash = require("./img/blue-wash.png");
const hotFuzz = require("./img/quiz/poster-round/hot-fuzz.png");
const titanic = require("./img/quiz/poster-round/titanic.png");
const mrBean = require("./img/quiz/poster-round/mr-beans-holiday.png");
const nightmareBeforeChristmas = require("./img/quiz/poster-round/nightmare-before-christmas.png");
const isleOfDogs = require("./img/quiz/poster-round/isle-of-dogs.png");

const presentation: Presentation = {
	title: "Quiz",
	slides: [
		{
			content: `
## The Quiz that nobody wants to do

# 😢
`,
		},
		{
			content: `
# Round 1 - Painted Posters

#### Can you guess these masterpieces?
`,
			justify: "-",
		},
		{
			content: `
Q1.1

![hf](${hotFuzz})
`,
			notes: "Hot Fuzz",
		},
		{
			content: `
Q1.2

![hf](${titanic})
`,
			notes: "Titanic",
		},
		{
			content: `
Q1.3

![hf](${mrBean})
`,
			notes: "Mr Bean's Holiday",
		},
		{
			content: `
Q1.4

![hf](${nightmareBeforeChristmas})
`,
			notes: "Nightmare before Christmas",
		},
		{
			content: `
Q1.5

![hf](${isleOfDogs})
`,
			notes: "Isle of dogs\nLast question of the round",
		},
		{
			content: `
# Round 2 - Going viral

### _And I'm not talking corona..._
`,
			justify: "-",
		},
		{
			content: `
q2.1

### What year was the video "Charlie bit my finger" uploaded to youtube?
`,
			notes: `873,676,707 views | May 22, 2007`,
		},
		{
			content: `
Q2.2

### Which video has more views?

#### Justin Beiber - Baby

#### Baby Shark
`,
			notes: `Baby: 2.2b\nBaby Shark: 5.1b`,
		},
		{
			content: `
Q2.3

### What 2017 _meme_ features Turkish chef Nusret Gökçe?
`,
			notes: `Salt Bae\nhttps://www.youtube.com/watch?v=J5GGG0PaSe4`,
		},
		{
			content: `
Q2.4

### What is the name of this emoji?

# 🤙
`,
			notes: `Call me hand\nAdded to unicode spec in 2016. Added to unicode 9.0 / Emoji 3.0`,
		},
		{
			content: `
Q2.5

### In 2014, many celebrities smart phones were hacked and their private photos were leaked to the internet.

### What famous hacker carried out this attack?
`,
			notes: `4Chan\nhttps://www.youtube.com/watch?v=kRcdmbC0HHs\nLast question of the round`,
		},
		{
			content: `
Round 3 - General Knowledge
`,
		},
		{
			content: `
Q3.1

### What is the capital city of [COUNTRY]?
`,
			notes: ``,
		},
		{
			content: `
Q3.2

###
`,
			notes: ``,
		},
	],
	theme: {
		transition: "swipeLeft",
		primaryColor: `rgba(20,90,50,0.9)`,
		rootFontSize: "40pt",
	},
	style: {
		fontSize: "1rem",
		backgroundImage: `url(${blueWash})`,
	},
};

export default presentation;
